import React from 'react';
import { ShimmerBox } from '../PageSkeleton/PageSkeleton';

const FormSectionSkeleton: React.FC<{
    fields?: number;
    title?: string;
}> = ({ fields = 6, title }) => (
    <section
        className="flex h-full flex-col rounded-xl shadow-lg border"
        style={{ background: 'var(--bg-card)', borderColor: 'var(--border-subtle)' }}
    >
        <div
            className="sticky top-0 z-10 border-b px-6 py-4 rounded-t-[var(--radius-lg)] flex items-center justify-between"
            style={{ background: 'var(--primary-25)', borderColor: 'var(--border-subtle)' }}
        >
            {title ? (
                <h2 className="text-lg font-bold" style={{ color: 'var(--text-heading)' }}>
                    {title}
                </h2>
            ) : (
                <ShimmerBox className="h-5 w-44 rounded-md" delay="0s" />
            )}
        </div>
        <div className="relative flex-1 px-6 py-4 overflow-hidden max-h-[calc(100vh-440px)]">
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                {Array.from({ length: fields }).map((_, i) => (
                    <ShimmerBox
                        key={i}
                        className="h-[58px] w-full rounded-[var(--radius-md)]"
                        delay={`${i * 0.06}s`}
                    />
                ))}
            </div>
        </div>
        <div
            className="sticky bottom-0 z-10 px-6 py-4 border-t rounded-b-[var(--radius-lg)] flex items-center justify-end"
            style={{ background: 'var(--bg-surface)', borderColor: 'var(--border-subtle)' }}
        >
            <ShimmerBox className="h-9 w-20 rounded-lg" delay="0s" />
        </div>
    </section>
);

export default FormSectionSkeleton;
